const MONTHS = [
  'มกราคม',
  'กุมภาพันธ์',
  'มีนาคม',
  'เมษายน',
  'พฤษภาคม',
  'มิถุนายน',
  'กรกฎาคม',
  'สิงหาคม',
  'กันยายน',
  'ตุลาคม',
  'พฤศจิกายน',
  'ธันวาคม',
];

export const dateFullFormat = date => {
  try {
    if (date && !isNaN(new Date(date))) {
      const newDate = new Date(date);
      return `${newDate.getDate()} ${MONTHS[newDate.getMonth()]} ${newDate.getFullYear()}`;
    }
    return null;
  } catch (err) {
    return null;
  }
};

export const dateDDMMYYFormat = date => {
  try {
    if (date && !isNaN(new Date(date))) {
      const newDate = new Date(date);
      return `${newDate.getDate() > 9 ? newDate.getDate() : `0${newDate.getDate()}`}/${(newDate.getMonth() + 1) > 9 ? newDate.getMonth() + 1 : `0${newDate.getMonth() + 1}`}/${newDate.getFullYear().toString().substr(-2)}`;
    }
    return null;
  } catch (err) {
    return null;
  }
};

export const dateYYMMDDFormat = date => {
  try {
    if (date && !isNaN(new Date(date))) {
      const newDate = new Date(date);
      return `${newDate.getFullYear().toString().substr(-2)}${(newDate.getMonth() + 1) > 9 ? newDate.getMonth() + 1 : `0${newDate.getMonth() + 1}`}${newDate.getDate() > 9 ? newDate.getDate() : `0${newDate.getDate()}`}`;
    }
    return null;
  } catch (err) {
    return null;
  }
};

export const dateDDMMYYYYFormat = date => {
  try {
    if (date && !isNaN(new Date(date))) {
      const newDate = new Date(date);
      return `${newDate.getDate() > 9 ? newDate.getDate() : `0${newDate.getDate()}`}/${(newDate.getMonth() + 1) > 9 ? newDate.getMonth() + 1 : `0${newDate.getMonth() + 1}`}/${newDate.getFullYear()}`;
    }
    return null;
  } catch (err) {
    return null;
  }
};

export const dateDMYYYYFormat = date => {
  try {
    if (date && !isNaN(new Date(date))) {
      const newDate = new Date(date);
      return `${newDate.getDate()}/${newDate.getMonth() + 1}/${newDate.getFullYear()}`;
    }
    return null;
  } catch (err) {
    return null;
  }
};

// formateDate ex: 2019-09-22
export const dateYYYYMMDD = date => {
  try {
    if (date && !isNaN(new Date(date))) {
      const newDate = new Date(date);
      return `${newDate.getFullYear()}-${(newDate.getMonth() + 1) > 9 ? (newDate.getMonth() + 1) : `0${newDate.getMonth() + 1}`}-${newDate.getDate() > 9 ? newDate.getDate() : `0${newDate.getDate()}`}`;
    }
    return null;
  } catch (error) {
    return null;
  }
};

export const dateUTCYYYYMMDD = date => {
  try {
    if (date && !isNaN(new Date(date))) {
      const newDate = new Date(date);
      return `${newDate.getUTCFullYear()}-${(newDate.getUTCMonth() + 1) > 9 ? (newDate.getUTCMonth() + 1) : `0${newDate.getUTCMonth() + 1}`}-${newDate.getUTCDate() > 9 ? newDate.getUTCDate() : `0${newDate.getUTCDate()}`}`;
    }
    return null;
  } catch (error) {
    return null;
  }
};

export const dateYYYYMMDDTimeHHMMSS = date => {
  try {
    if (date && !isNaN(new Date(date))) {
      const newDate = new Date(date);
      return `${newDate.getDate() > 9 ? newDate.getDate() : `0${newDate.getDate()}`}/${(newDate.getMonth() + 1) > 9 ? newDate.getMonth() + 1 : `0${newDate.getMonth() + 1}`}/${newDate.getFullYear()} ${newDate.getHours() > 9 ? newDate.getHours() : `0${newDate.getHours()}`}:${newDate.getMinutes() > 9 ? newDate.getMinutes() : `0${newDate.getMinutes()}`}:${newDate.getSeconds() > 9 ? newDate.getSeconds() : `0${newDate.getSeconds()}`}`;
    }
    return null;
  } catch (error) {
    return null;
  }
};

export const isWeekDay = date => {
  try {
    if (date) {
      const newDate = new Date(date);
      const dayOfTheWeek = newDate.getDay();
      return !(dayOfTheWeek === 0 || dayOfTheWeek === 6);
    }
  } catch (err) {
    return null;
  }
};
